import Game from "Game";
import { EventStateHelper } from "State/Events/EventStateHelper";
import { IGameState } from "State/Game/IGameState";

export default function preloadEvents(state: IGameState) {
    const activeEvents = EventStateHelper.getActiveEvents(state);
    const activeEventsWithAssets = activeEvents.filter(event => event.assets?.length > 0);

    // Add each asset from each event
    activeEventsWithAssets.forEach(event => {
        event.assets.forEach(asset => {

            // Use the asset value from `events.json` as both the name and URL of the asset. This ensures the
            // `ResourceManager` properly looks up the atlas png and loads the webp version instead - if supported.
            Game.resource.add(asset, asset);
        });
    });
}
